import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlame = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 151,
	height: 204,
	viewBox: "0 0 151 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4221 196.16C48.1221 192.21 34.6022 184.77 22.5822 173.61C10.5622 162.45 2.55211 145.46 6.54211 129.55C10.6821 113 25.9221 102.17 37.3221 89.4904C48.7221 76.8004 56.2921 55.9103 44.4221 43.6603C51.1221 50.0403 54.892 58.0603 59.842 68.2803C64.792 78.5003 65.7121 98.3903 56.4321 104.95C67.5921 98.1103 75.592 86.3303 77.842 73.4403C79.752 62.5203 77.7021 51.1703 79.8121 40.2903C83.0921 23.3603 97.1921 9.04031 114.062 5.50031C96.7321 27.8503 97.6421 62.4103 116.122 83.8103C120.292 76.7603 121.912 68.1103 118.632 61.1503C135.912 79.0603 124.742 126.89 100.932 147.73C119.182 138.19 131.832 118.74 133.152 98.1903C135.502 121.43 151.802 145.11 141.902 166.26C139.032 172.4 134.172 177.42 128.832 181.61C111.292 195.38 87.5621 201.05 65.7421 196.43C65.4021 196.36 64.7321 196.22 64.4021 196.14L64.4221 196.16Z",
			stroke: "white",
			strokeWidth: 11,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4221 196.16C48.1221 192.21 34.6022 184.77 22.5822 173.61C10.5622 162.45 2.55211 145.46 6.54211 129.55C10.6821 113 25.9221 102.17 37.3221 89.4904C48.7221 76.8004 56.2921 55.9103 44.4221 43.6603C51.1221 50.0403 54.892 58.0603 59.842 68.2803C64.792 78.5003 65.7121 98.3903 56.4321 104.95C67.5921 98.1103 75.592 86.3303 77.842 73.4403C79.752 62.5203 77.7021 51.1703 79.8121 40.2903C83.0921 23.3603 97.1921 9.04031 114.062 5.50031C96.7321 27.8503 97.6421 62.4103 116.122 83.8103C120.292 76.7603 121.912 68.1103 118.632 61.1503C135.912 79.0603 124.742 126.89 100.932 147.73C119.182 138.19 131.832 118.74 133.152 98.1903C135.502 121.43 151.802 145.11 141.902 166.26C139.032 172.4 134.172 177.42 128.832 181.61C111.292 195.38 87.5621 201.05 65.7421 196.43C65.4021 196.36 64.7321 196.22 64.4021 196.14L64.4221 196.16Z",
			fill: "url(#paint0_linear_15_1129)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_15_1129",
			x1: 67.2588,
			y1: 183.053,
			x2: 113.769,
			y2: -39.6399,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .15,
					stopColor: "#EBBA4A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .39,
					stopColor: "#E1973B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .62,
					stopColor: "#DB7E31"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .83,
					stopColor: "#D76F2B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D66A29"
				})
			]
		}) })
	]
});
export default SvgFlame;
